import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { Subject } from 'rxjs';
import {
  generateMockTerritories,
  MockTerritory,
} from './temp-mocks/mock-territory';

@Component({
  selector: 'app-territory-selection',
  templateUrl: './territory-selection.component.html',
  styleUrls: ['./territory-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TerritorySelectionComponent implements OnDestroy {
  @Input() selectedTerritories: MockTerritory[];

  destroyed$ = new Subject<void>();
  protected allSelected = false;
  protected showAllCustomers = false;
  protected initializeSelected = true;
  protected territories: MockTerritory[] = generateMockTerritories();
  private platformType = this.platformService.platformEnum;

  constructor(
    private modalController: ModalController,
    protected platformService: PlatformService,
  ) {}

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  get isDesktop(): boolean {
    return this.platformService.getPlatformType() === this.platformType.desktop;
  }

  get isTablet(): boolean {
    return this.platformService.getPlatformType() === this.platformType.tablet;
  }

  get isMobile(): boolean {
    return this.platformService.getPlatformType() === this.platformType.mobile;
  }

  close() {
    this.modalController.dismiss();
  }

  formatCustomerName(customer: MockTerritory) {
    return [customer.firstName, customer.lastName]
      .filter(name => !!name)
      .join(' ');
  }

  selectCustomer(customerSelectionOption: MockTerritory, index: number) {}

  selectAllCustomers() {}

  filterSelectedCustomers() {}
}
